module.exports = __webpack_public_path__ + "img/Dairy_Queen_logo.98711bc2.svg";